module.exports = __webpack_public_path__ + "loanmarket-concierge.ae9a72a47d44aafd6038d4f65f583b24.png";